// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__28grF","content":"LayoutSettings_content__2jdWD"};